import { render, staticRenderFns } from "./SuccessionFile.vue?vue&type=template&id=56eb6852&"
import script from "./SuccessionFile.vue?vue&type=script&lang=js&"
export * from "./SuccessionFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports